import styled from 'styled-components';
import {
  colorsVariables,
  fontVariables,
  Icon
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import { ListMinusIcon } from 'components/Illustrations/ListMinusIcon/ListMinusIcon';
import { minWidth } from 'helpers/buildMediaQueries';

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: #344054;
  font-weight: 400;
  padding: 2px 0;
  text-align: left;

  ${minWidth('md', `color: ${colorsVariables.WHITE};`)}
`;

export const TooltipHeading = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 4px;
  font-weight: ${fontVariables.FONT_WEIGHT_MEDIUM};
  color: #101828;
  font-size: 18px;
  line-height: 150%;

  ${minWidth('md', `color: ${colorsVariables.WHITE}; font-size: inherit;`)}
`;

export const TooltipBody = styled.div`
  padding-left: 24px;
  font-size: 16px;
  line-height: 24px;

  ${minWidth(
    'md',
    `color: ${colorsVariables.WHITE}; font-size: 12px; line-height: 20px;`
  )}
`;

export const CheckIcon = styled(Icon)`
  margin-right: 8px;
`;

export const BodyTextWithBulletPoints = styled.span`
  white-space: break-spaces;
  margin-bottom: 8px;
  padding-left: 22px;
  font-size: 16px;
  line-height: 24px;

  ${minWidth(
    'md',
    `color: ${colorsVariables.WHITE}; font-size: 12px; line-height: 20px;`
  )}
`;

export const ListMinusIconWithMargin = styled(ListMinusIcon)`
  margin-right: 8px;
  width: 18px;
  height: 18px;
  min-width: 18px;
`;
